// Fonte: UManutContas.pas — Panel17, dsCidEnde → tabela Endereco_Cobranca
import React, { useState, useEffect, useCallback } from 'react';
import { Card, Form, Row, Col, Button, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import {
  buscarEnderecoCobrancaConta,
  salvarEnderecoCobrancaConta,
  excluirEnderecoCobrancaConta,
} from '~/Services/Service';
import aplicarMascara from '../components/mascaras';

var TabEnderecoCobranca = function(_ref) {
  var ge = _ref.ge;
  var codigo = _ref.codigo;
  var cidades = _ref.cidades !== null && _ref.cidades !== undefined ? _ref.cidades : [];

  var [dados, setDados] = useState(null);
  var [loading, setLoading] = useState(false);
  var [editando, setEditando] = useState(false);
  var [form, setForm] = useState({ endereco: '', bairro: '', cep: '', codigo_cidade: '' });
  var [salvando, setSalvando] = useState(false);

  var carregar = useCallback(function() {
    if (!ge || !codigo) return;
    setLoading(true);
    buscarEnderecoCobrancaConta(ge, codigo)
      .then(function(resp) {
        setDados(resp);
        if (resp) {
          setForm({
            endereco: resp.endereco !== null && resp.endereco !== undefined ? resp.endereco : '',
            bairro: resp.bairro !== null && resp.bairro !== undefined ? resp.bairro : '',
            cep: resp.cep !== null && resp.cep !== undefined ? resp.cep : '',
            codigo_cidade: resp.codigo_cidade !== null && resp.codigo_cidade !== undefined ? resp.codigo_cidade : '',
          });
        }
      })
      .catch(function() { toast.error('Erro ao carregar endereço de cobrança'); })
      .finally(function() { setLoading(false); });
  }, [ge, codigo]);

  useEffect(function() { carregar(); }, [carregar]);

  var handleSalvar = function() {
    if (!form.endereco) { toast.warning('Informe o endereço'); return; }
    if (!form.codigo_cidade) { toast.warning('Selecione a cidade'); return; }
    setSalvando(true);
    salvarEnderecoCobrancaConta(ge, codigo, form)
      .then(function() {
        toast.success('Endereço de cobrança salvo!');
        setEditando(false);
        carregar();
      })
      .catch(function() { toast.error('Erro ao salvar endereço de cobrança'); })
      .finally(function() { setSalvando(false); });
  };

  var handleExcluir = function() {
    excluirEnderecoCobrancaConta(ge, codigo, {})
      .then(function() {
        toast.success('Endereço de cobrança removido!');
        setDados(null);
        setForm({ endereco: '', bairro: '', cep: '', codigo_cidade: '' });
      })
      .catch(function() { toast.error('Erro ao excluir endereço de cobrança'); });
  };

  if (loading) return <div className="text-center py-3"><Spinner animation="border" /></div>;

  return (
    <div className="contas-tab-content">
      {!editando && dados && (
        <div className="d-flex justify-content-end mb-2">
          <Button size="sm" variant="outline-primary" className="mr-2" onClick={function() { setEditando(true); }}>Editar</Button>
          <Button size="sm" variant="outline-danger" onClick={handleExcluir}>Remover</Button>
        </div>
      )}
      {(!dados || editando) && (
        <div className="d-flex justify-content-end mb-2">
          <Button size="sm" variant="primary" onClick={function() { setEditando(true); }}>
            {dados ? 'Editar' : 'Informar Endereço de Cobrança'}
          </Button>
        </div>
      )}

      {dados && !editando ? (
        <Card className="border-0">
          <Card.Body className="py-2">
            <Row>
              <Col md={4}><small className="text-muted">Endereço:</small><br />{dados.endereco}</Col>
              <Col md={2}><small className="text-muted">Bairro:</small><br />{dados.bairro !== null && dados.bairro !== undefined ? dados.bairro : '-'}</Col>
              <Col md={2}><small className="text-muted">CEP:</small><br />{dados.cep !== null && dados.cep !== undefined ? dados.cep : '-'}</Col>
              <Col md={3}><small className="text-muted">Cidade:</small><br />{dados.descricao_cidade !== null && dados.descricao_cidade !== undefined ? dados.descricao_cidade : '-'}</Col>
            </Row>
          </Card.Body>
        </Card>
      ) : editando ? (
        <Row>
          <Col md={4}>
            <Form.Group>
              <Form.Label className="small">Endereço *</Form.Label>
              <Form.Control type="text" size="sm"
                value={form.endereco}
                onChange={function(e) { var v = e.target.value; setForm(function(f) { return { ...f, endereco: v }; }); }}
                maxLength={40}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label className="small">Bairro</Form.Label>
              <Form.Control type="text" size="sm"
                value={form.bairro}
                onChange={function(e) { var v = e.target.value; setForm(function(f) { return { ...f, bairro: v }; }); }}
                maxLength={20}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label className="small">CEP</Form.Label>
              <Form.Control type="text" size="sm"
                value={aplicarMascara(form.cep, 'cep')}
                onChange={function(e) { var v = String(e.target.value).replace(/\D/g, ''); setForm(function(f) { return { ...f, cep: v }; }); }}
                maxLength={9}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label className="small">Cidade *</Form.Label>
              <Select
                placeholder="Selecione..."
                options={cidades}
                value={cidades.find(function(c) { return c.value === form.codigo_cidade; }) || null}
                onChange={function(opt) { setForm(function(f) { return { ...f, codigo_cidade: opt ? opt.value : '' }; }); }}
                isClearable
                noOptionsMessage={function() { return 'Nenhuma cidade'; }}
              />
            </Form.Group>
          </Col>
          <Col md={1} className="d-flex align-items-end mb-3">
            <div>
              <Button size="sm" variant="success" className="mr-1" onClick={handleSalvar} disabled={salvando}>
                {salvando ? <Spinner animation="border" size="sm" /> : 'Salvar'}
              </Button>
              <Button size="sm" variant="secondary" onClick={function() { setEditando(false); }}>X</Button>
            </div>
          </Col>
        </Row>
      ) : (
        <p className="text-muted text-center">Nenhum endereço de cobrança cadastrado.</p>
      )}
    </div>
  );
};

export default TabEnderecoCobranca;
